export { generateColorFromString, getColorByString } from "./stringToColor";
export { default as generateRandomColor } from "./generateRandomColor";
